module.exports = __webpack_public_path__ + "static/media/20ECE8.b81d2186.jpg";